import { ContentSwitcher } from '@iwoca/orion';

export type PackageLinkView = 'ACTIVE' | 'ARCHIVED';

export const PackageLinkViewSwitcher = ({
  currentView,
  onChange,
}: {
  currentView: PackageLinkView;
  onChange: (view: PackageLinkView) => void;
}) => {
  return (
    <ContentSwitcher value={currentView} className="mb-xl">
      <ContentSwitcher.Button
        id="ACTIVE"
        onClick={() => onChange('ACTIVE')}
        className="cursor-pointer !px-xl"
      >
        All
      </ContentSwitcher.Button>
      <ContentSwitcher.Button
        id="ARCHIVED"
        onClick={() => onChange('ARCHIVED')}
        className="cursor-pointer !px-xl"
      >
        Archived
      </ContentSwitcher.Button>
    </ContentSwitcher>
  );
};
